import { Component, ElementRef, Input, Output, EventEmitter, Renderer2, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, AbstractControl, ValidationErrors, Validator } from '@angular/forms';


@Component({
  selector: 'atom-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})

export class InputComponent implements ControlValueAccessor, Validator {
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() required: boolean = false;
  @Input() minLength?: number;
  @Input() maxLength?: number;
  @Input() isPasswordField: boolean = false;
  @Input() inputBackgroundColor: string = 'unset';
  @Input() inputTextColor: string = '#000000';
  @Input() borderColor: string = '#000000';
  @Input() buttonColor: string = '#000000';
  @Input() disabled: boolean = false;
  @Input() passwordIcon: string = 'visibility_off';
  @Output() togglePassword = new EventEmitter<void>();
  

  value: string = '';
  passwordValue: string = '';
  isPasswordVisible: boolean = false;
  isPasswordDisabled: boolean = false;

  private onChange = (_: any) => {};
  private onTouched = () => {};

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    const inputElement = this.el.nativeElement.querySelector('input');
    this.renderer.setStyle(inputElement, 'border-color', this.borderColor);
  }
  

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.value = inputElement.value;
    this.onChange(this.value);
  }

  onBlur(): void {
    this.onTouched();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.required && !this.value) {
      return { required: true };
    }
    if (this.minLength && this.value.length < this.minLength) {
      return { minlength: { requiredLength: this.minLength, actualLength: this.value.length } };
    }
    if (this.maxLength && this.value.length > this.maxLength) {
      return { maxlength: { requiredLength: this.maxLength, actualLength: this.value.length } };
    }
    return null;
  }

  togglePasswordVisibility(): void {
    this.type = this.type === 'password' ? 'text' : 'password';
    this.togglePassword.emit();
  }

  onPasswordInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.passwordValue = inputElement.value;
  }

  onPasswordBlur(): void {
    // Handle blur event if necessary
  }

}

